import { IOptions } from '../../../common/common.types'
import { IRootState } from '../../../store'

export const getCrewListDataSelector = (state: IRootState): IOptions => state.crew.crewListData
